import { render, staticRenderFns } from "./recharge_edit.vue?vue&type=template&id=648b35e2&scoped=true&"
import script from "./recharge_edit.vue?vue&type=script&lang=js&"
export * from "./recharge_edit.vue?vue&type=script&lang=js&"
import style0 from "./recharge_edit.vue?vue&type=style&index=0&id=648b35e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648b35e2",
  null
  
)

export default component.exports